import React, { useCallback, useMemo } from 'react'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'

import { TtAvatar } from '@23/ui-react'

import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'
import useSpeakersQuery from '../../hooks/useSpeakersQuery'
import { WebinarPanelComponent } from '../../features/WebinarSidebarFeature/components'

import { AttendeeDemoter } from './attendee-demoter'
import GenericSpeakerList, {
  type GenericSpeakerListItemProps,
} from './GenericSpeakerList'

import './WebinarInfoSidebarGuestSpeakerList.scss'

const SpeakerEntry = ({ speaker }: GenericSpeakerListItemProps) => {
  const { id, name, fullName, question, guestSpeakerPreviewLink } = speaker
  const { tabs } = useWebinarColors()

  return (
    <div
      key={id}
      className="webinar-info-sidebar-guest-speaker-list-item"
      style={{ borderBottomColor: tabs.contrast.transparent('5%') }}
    >
      <TtAvatar label={name} image={guestSpeakerPreviewLink} />
      <div className="speaker-info">
        <div className="speaker-info-name">
          <span className="speaker-info-short-name">
            <FormattedMessage
              defaultMessage="{fullName}<conditional>(shown as {name})</conditional>"
              values={{
                fullName,
                name,
                // eslint-disable-next-line react/no-unstable-nested-components
                conditional: (...chunks) => (
                  <>{fullName !== name ? chunks : ''}</>
                ),
              }}
            />
          </span>
        </div>
        <div className="speaker-info-subline">
          {question && (
            <FormattedMessage
              defaultMessage="Question: {question}"
              values={{ question }}
            />
          )}
        </div>
      </div>
      <AttendeeDemoter attendeeId={id} attendeeName={name} />
    </div>
  )
}

const WebinarInfoSidebarGuestSpeakerList = () => {
  const { data } = useSpeakersQuery()

  const guestFilter = useCallback(
    (speaker) => speaker.creationSource === 'guest',
    []
  )

  const speakers = useMemo(() => data?.filter(guestFilter), [data, guestFilter])

  const renderGuestItem = useCallback(
    ({ speaker }) => <SpeakerEntry key={speaker.id} speaker={speaker} />,
    []
  )

  return (
    speakers &&
    speakers.length > 0 && (
      <div className="section">
        <div className="section-title">
          <FormattedMessage defaultMessage="On camera" />
        </div>
        <WebinarPanelComponent>
          <div className="webinar-info-sidebar-guest-speaker-list">
            <GenericSpeakerList
              filter={guestFilter}
              renderItem={renderGuestItem}
              placeholder={intl.formatMessage({
                defaultMessage: 'No one is currently on camera',
              })}
            />
          </div>
        </WebinarPanelComponent>
      </div>
    )
  )
}

export { WebinarInfoSidebarGuestSpeakerList }
